import React, { Component } from "react";
import PropTypes from "prop-types";
import io from "socket.io-client";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";

import { server } from "../../config/vars";
import { store } from "../../store";

import { incoming, outgoing } from "./eventTypes";
import { handleLoadParty } from "../Votify/VotifyParty/partyActionCreators";
import {
  handleLoadQueue,
  loadTrackDetails,
} from "../Votify/VotifyQueue/queueActionCreators";
import {
  handleLoadPlayback,
  handleNextTrack,
} from "../Votify/VotifyPlayback/playbackActionCreators";
import {
  handleLoadVotes,
  handleVote,
} from "../Votify/VotifyParticipant/participantActionCreators";
import {
  handleConnection,
  handleLostConnection,
  handleSocketAck,
  handleSocketNotAck,
  handleMessage,
} from "./socketActionCreators";
import { handleNoDevice } from "../Votify/VotifyHost/hostActionCreators";

const socket = io(server.uri);
console.log("LOADING MODULE SOCKETIO COMPONENT");

const LAST_UPDATED_TIMEOUT_S = 15;

socket.on("connect", () => {
  console.info("Got connection");
  store.dispatch(handleConnection());
});

socket.on(incoming.QUEUE, (queue) => {
  console.info("Got a new queue");
  console.info(queue);
  store.dispatch(handleLoadQueue(queue));
});
socket.on(incoming.PLAYBACK, (playback) => {
  console.info("Got updated playback");
  console.info(playback);
  store.dispatch(handleMessage());
  store.dispatch(handleLoadPlayback(playback));
});
socket.on(incoming.VOTES, (votes) => {
  console.info("Got updated votes");
  console.info(votes);
  store.dispatch(handleLoadVotes(votes));
  store.dispatch(
    loadTrackDetails(
      votes.map((vote) => vote.trackId).filter((trackId) => !_.isNil(trackId)),
    ),
  );
});
socket.on(incoming.VOTE, (vote) => {
  console.info("Got a single vote");
  console.info(vote);
  store.dispatch(handleVote(vote));
  store.dispatch(
    loadTrackDetails([vote.trackId].filter((trackId) => !_.isNil(trackId))),
  );
});

socket.on(incoming.MESSAGE, (data) => {
  console.info("Got a message");
  console.info(data);
});
socket.on(incoming.NEXT_SONG, (data) => {
  console.info("Got a next track event");
  console.info(data);
  store.dispatch(handleNextTrack(data));
});

socket.on(incoming.ACK_JOIN_PARTY, (data) => {
  console.info("Got a joined party event");
  console.info(data);
  if (data.ok) {
    store.dispatch(handleLoadParty(data));
    store.dispatch(handleSocketAck(data));
  } else {
    store.dispatch(handleSocketNotAck(data));
  }
});
socket.on(incoming.PARTY, (data) => {
  console.info("Got a party event");
  store.dispatch(handleLoadParty(data));
});

socket.on(incoming.NO_DEVICE, (data) => {
  console.info("Got a no device event");
  store.dispatch(handleNoDevice(data));
});
socket.on(incoming.NOT_AUTHORIZED, (data) => {
  console.info("Got a not authorized event");
  store.dispatch(handleNoDevice(data));
});

const mapStateToProps = (state) => {
  return {
    isLookingForParty: state.party.isLookingForParty,
    hasAckParty: state.party.hasAckParty,
    hasFoundParty: state.party.hasFoundParty,
    socketTimeoutMs: state.party.socketTimeoutMs,
    partyId: state.party.partyId,
    lastUpdated: state.socket.lastUpdated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleQueue: (queue) => dispatch(handleLoadQueue(queue)),
    handlePlayback: (playback) => dispatch(handleLoadPlayback(playback)),
    handleParty: (party) => dispatch(handleLoadParty(party)),
    handleNextTrack: (track) => dispatch(handleNextTrack(track)),
    handleVote: (vote) => dispatch(handleVote(vote)),
    handleVotes: (votes) => dispatch(handleLoadVotes(votes)),

    handleConnection: () => dispatch(handleConnection()),
    failJoinParty: () => dispatch(handleSocketNotAck()),
    synJoinParty: () => dispatch(handleSocketAck()),
    lostSocketConnection: (timeout) => dispatch(handleLostConnection(timeout)),
  };
};

class SocketIoComponent extends Component {
  constructor(props) {
    super(props);
    console.log("SOCKET IO COMPONENT CONSTRUCTOR");

    this.state = {
      joinPartyRetries: 0 /** Used to delay join party events when many unsuccessful retries */,
      joinPartyCounter: 0 /** Used to delay join party events when many unsuccessful retries */,
    };
  }

  isTimeout() {
    const now = moment();
    const result =
      now.unix() - this.props.lastUpdated.unix() > LAST_UPDATED_TIMEOUT_S;
    return result;
  }

  componentDidMount() {
    console.log("SocketIoComponent DidMount");
    console.log("this.props.isExistingParty");
    console.log(this.props.isExistingParty);
    console.log("this.props.partyId");
    console.log(this.props.partyId);
    console.log("shouldEmitJoinParty");
    console.log(this.props.isLookingForParty && !this.props.hasAckParty);

    console.log(
      `Ready to connect bcz initiate, should: ${this.props.isLookingForParty &&
        !this.props.hasAckParty}`,
    );

    if (this.props.isLookingForParty && !this.props.hasAckParty) {
      console.info(`Emitting joinParty to ${this.props.partyId}`);
      socket.emit(outgoing.JOIN_PARTY, { partyId: this.props.partyId });
    }
    this.interval = setInterval(() => {
      const { joinPartyCounter, joinPartyRetries } = this.state;
      if (
        (this.props.isLookingForParty && !this.props.hasAckParty) ||
        this.isTimeout()
      ) {
        if (joinPartyCounter >= joinPartyRetries) {
          console.log(`Emitting JOIN_PARTY ${this.props.partyId}`);
          socket.emit(outgoing.JOIN_PARTY, { partyId: this.props.partyId });
          this.setState({
            joinPartyCounter: 0,
            joinPartyRetries: joinPartyRetries + 1,
          });
        } else {
          this.setState({ joinPartyCounter: joinPartyCounter + 1 });
        }
      } else {
        this.setState({ joinPartyRetries: 0 });
      }
    }, 2000);
  }

  componentWillReceiveProps(newProps) {
    const shouldEmitJoinParty = this.props.isLookingForParty;
    if (newProps.partyId !== this.props.partyId && shouldEmitJoinParty) {
      console.log("Emitting join party because party has changed.");
      socket.emit(outgoing.JOIN_PARTY, { partyId: newProps.partyId });
    }
  }

  componentWillUnmount() {
    console.log("SocketIoComponent componentWillUnmount");
    clearInterval(this.interval);
  }

  render() {
    return <div />;
  }
}

SocketIoComponent.propTypes = {
  handleQueue: PropTypes.func.isRequired,
  handleParty: PropTypes.func.isRequired,
  handlePlayback: PropTypes.func.isRequired,
  handleVote: PropTypes.func.isRequired,
  handleNextTrack: PropTypes.func.isRequired,
  handleVotes: PropTypes.func.isRequired,
  lostSocketConnection: PropTypes.func.isRequired,
  failJoinParty: PropTypes.func.isRequired,
  synJoinParty: PropTypes.func.isRequired, // Confirm that the server has added client to room

  socketTimeoutMs: PropTypes.number,
  partyId: PropTypes.string,
  isLookingForParty: PropTypes.bool,
  hasAckParty: PropTypes.bool,
  hasFoundParty: PropTypes.bool,
  isLoadingParty: PropTypes.bool,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SocketIoComponent);
